import { portfolioTypes } from '../types/portfolio'

const initialState = {
  portfolioLoading: false,
  portfolio: [],
  error: '',
}

export const portfolioReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case portfolioTypes.GET_PORTFOLIO_SUCCESS:
      return {
        ...state,
        portfolio: action.payload,
      }

    default:
      return state
  }
}
